import {Activity} from 'lucide-react';
import type {RouteObject} from 'react-router-dom';

import type {MenuItemElement} from '@/components/menu/Menu';
import i18n from '@/i18n';
import {protectedLoader} from '@/utils/protectedLoader';

export const routes = [
  {
    path: 'rehabilitation',
    children: [
      {
        path: '',
        loader: protectedLoader('REHABILITATION', 'MANAGE_REHABILITATION'),
        async lazy() {
          const {RehabilitationListPage} = await import(
            './pages/RehabilitationListPage'
          );
          return {element: <RehabilitationListPage />};
        },
      },
      {
        path: ':id',
        loader: protectedLoader('REHABILITATION', 'MANAGE_REHABILITATION'),
        async lazy() {
          const {RehabilitationPage} = await import(
            './pages/RehabilitationPage'
          );
          return {element: <RehabilitationPage />};
        },
      },
    ],
  },
] as RouteObject[];

export const menuItems = [
  {
    path: '/rehabilitation',
    text: i18n.t('Rehabilitation'),
    icon: <Activity />,
    permission: 'MANAGE_REHABILITATION',
    entitlement: 'REHABILITATION',
  },
] as MenuItemElement[];
